import {
  Box, Collapse, Stack, Typography,
} from '@mui/material';
import Icon from 'components/Icon';
import Row from 'components/Row';
import { CartContext } from 'constants/contexts';
import React, { useContext, useState } from 'react';

function CateringMenuHours() {
  const [open, setOpen] = useState(false);
  const { openingHours } = useContext(CartContext);
  return (
    <Box sx={{ width: { md: '65%' } }}>
      <Stack direction="row" alignItems="center" onClick={() => setOpen(!open)} gap={1}>
        <Typography variant="title-sm" sx={{ textDecoration: 'underline' }}>
          {open ? 'Hide' : 'View'}
          {' '}
          caterer’s hours
        </Typography>
        <Icon name={open ? 'arrow-up' : 'arrow-down'} />
      </Stack>
      <Collapse in={open}>
        {
          openingHours && Object.entries(openingHours).map(([day, hours]) => (
            <Row key={day}>
              <Typography variant="label-md" fontWeight="bold" textTransform="capitalize">{day.toLowerCase()}</Typography>
              <Stack flexDirection="row" flexWrap="wrap" textAlign="right" divider={<Typography fontSize={12} mx={1}> , </Typography>}>
                {
                  hours.map((h) => (
                    <Typography key={h.from_hour} variant="body-caption" textTransform="lowercase">
                      {h.from_hour}
                      {' '}
                      -
                      {' '}
                      {h.to_hour}
                    </Typography>
                  ))
                }
              </Stack>
            </Row>
          ))
        }
      </Collapse>
    </Box>
  );
}
export default CateringMenuHours;
